const Stripe = () => {
    return (
        <div className="bg-gradient-to-r from-brand-700 via-brand-600 to-brand-500 text-white text-[13px] py-2 px-4">
            <div className="container-narrow flex flex-wrap justify-center md:justify-end items-center gap-x-6 gap-y-1">
                <a
                    href="mailto:info@urbanfyzio.cz"
                    className="hidden md:inline-flex items-center gap-2 opacity-90 hover:opacity-100 transition-opacity"
                    aria-label="Send us an email at info@urbanfyzio.cz"
                >
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                    </svg>
                    info@urbanfyzio.cz
                </a>

                <a
                    href="tel:+420734312843"
                    className="inline-flex items-center gap-2 opacity-90 hover:opacity-100 transition-opacity"
                    aria-label="Call us at +420 734 312 843"
                >
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z" />
                    </svg>
                    +420 734 312 843
                </a>

                <a
                    href="https://urbanfyzio.reservio.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 font-semibold opacity-95 hover:opacity-100 transition-opacity"
                    aria-label="Book an appointment"
                >
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                        <line x1="16" y1="2" x2="16" y2="6" />
                        <line x1="8" y1="2" x2="8" y2="6" />
                        <line x1="3" y1="10" x2="21" y2="10" />
                    </svg>
                    Rezervovat termín
                </a>
            </div>
        </div>
    );
};

export default Stripe;
